import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-left-circle-icon',
  templateUrl: './code-left-circle.component.html'
})
export class CodeLeftCircleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
